export default {
  site_name: '久久热',
  site_tagline: '热门内容持续更新，尽享精彩',
  nav_home: '首页',
  nav_about: '关于我们',
  nav_categories: '分类',
  hero_title: '发现热门，追踪趋势',
  hero_subtitle: '海量精彩内容持续更新，覆盖娱乐、资讯、生活等多元领域，每天都有新鲜好内容',
  hero_cta: '探索热门内容',
  section_trending: '🔥 实时热点',
  section_hot: '热门推荐',
  section_latest: '最新文章',
  section_categories: '内容分类',
  section_related: '相关推荐',
  read_more: '阅读全文',
  view_count: '阅读',
  published_at: '发布于',
  back_home: '返回首页',
  breadcrumb_home: '首页',
  category_title: '分类',
  about_title: '关于我们',
  about_brand_title: '品牌故事',
  about_brand_desc: '久久热诞生于对优质内容的热爱。我们相信，在这个信息爆炸的时代，每个人都值得看到最精彩的内容。自创立以来，久久热始终坚持"内容为王"的核心理念，致力于打造一个汇聚热门资讯、传递正能量的内容平台。我们的编辑团队来自各大主流媒体，拥有丰富的行业经验和敏锐的内容嗅觉，24小时不间断为您筛选最值得关注的热点内容。',
  about_reputation_title: '用户口碑',
  about_contact_title: '联系我们',
  about_contact_desc: '如果您有任何建议、合作意向或内容投稿，欢迎通过以下方式联系我们。久久热期待与您的每一次交流。',
  contact_email_label: '电子邮箱',
  contact_name_label: '您的姓名',
  contact_message_label: '留言内容',
  contact_submit: '发送留言',
  contact_success: '留言发送成功！我们会尽快回复您。',
  contact_error: '发送失败，请稍后重试。',
  form_name: '久久热联系我们',
  footer_copyright: '© 2026 久久热 Jiujiure.com 版权所有',
  footer_privacy: '隐私政策',
  footer_terms: '服务条款',
  footer_about: '关于久久热',
  article_tags: '标签',
  article_author: '作者',
  search_placeholder: '搜索感兴趣的内容...',
  no_articles: '暂无相关文章',
  scroll_top: '返回顶部',
  category_all: '全部',
  reputation_1_name: '张明',
  reputation_1_role: '资深媒体人',
  reputation_1_text: '久久热已经成为我每天必看的内容平台。信息更新快、内容质量高，推荐算法也很精准，总能给我推荐真正感兴趣的内容。',
  reputation_2_name: '李婷',
  reputation_2_role: '互联网从业者',
  reputation_2_text: '作为一个每天都要追踪行业动态的人，久久热的科技频道就是我的信息雷达。分类清晰，文章有深度，非常好用。',
  reputation_3_name: '王浩',
  reputation_3_role: '大学生',
  reputation_3_text: '同学推荐的这个平台，用了一段时间真的爱上了。内容丰富又有趣，课余时间刷刷久久热已经成为习惯。',
  contact_address: '中国上海市浦东新区张江高科技园区',
  contact_phone: '+86 400-888-9999',
  contact_email: 'contact@jiujiure.com',
};